import React from 'react';
import {
  useGetAssignmentIncompleteScoringOptionMutation,
  useGetScoreReportMutation,
  useGetAssignmentPointsOPtionsMutation,
  usePatchAssignmentIncompleteScoringOptionMutation,
  usePatchAssignmentPointsOPtionsMutation
} from '../../../../../../features/authentication/reportApiSlice';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectFerpaState } from '../../../../../../features/authentication/authSlice';
import { faCheck, faClose, faInfo } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';
import DropDown from '../../../../../../components/DropDown';
import CustomToast from '../../../../../../components/Toast';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import { useLazyGetAssignmentQuery } from '../../../../../../features/authentication/assignmentApislice';
import {
  convertToCSV,
  downloadCSV,
  reorderObjectProperties
} from '../../../../utils';
import html2pdf from 'html2pdf.js';
import ProgressButton from '../../../../../../components/ProgressButton';
import FERPA from '../../../../../../components/FERPA/FerpaComponent';

const ScoreReport = () => {
  const [getScoreReport] = useGetScoreReportMutation();
  const navigate = useNavigate();
  const [loader, setLoader] = React.useState(false);
  const [ScoreReportData, setScoreReportData] = React.useState([]);
  const [incompleteScoringOption, setIncompleteScoringOption] = React.useState(false);
  const [classList, setClassList] = React.useState([]);
  const [selectedClassIds, setSelectedClassIds] = React.useState(-1);
  const ferpaEnabled = useSelector(selectFerpaState);
  const [getAssignmentIncompleteScoringOption] = useGetAssignmentIncompleteScoringOptionMutation();
  const [getAssignmentPointsOPtions] = useGetAssignmentPointsOPtionsMutation();
  const [patchAssignmentPointsOPtions] = usePatchAssignmentPointsOPtionsMutation();
  const [scoringOption, setScoringOption] = React.useState({
    point: false,
    percentage: false
  });
  const [patchAssignmentIncompleteScoringOption] =
    usePatchAssignmentIncompleteScoringOptionMutation();
  const { Id } = useParams();
  let pageNumber = 0;
  const [trigger] = useLazyGetAssignmentQuery({
    assignmentId: Id,
    pageNumber: pageNumber
  });
  const [selectedClassName, setSelectedClassName] = React.useState('');
  const [isClassChanged, setIsClassChanged] = React.useState(false);
  const [isNoData, setIsNoData] = React.useState(false);
  const [pageLoader, setPageLoader] = React.useState(true);
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);

  React.useEffect(() => {
    refetch();
    getIncompleteScoringOption();
    getPointOptions();
    fetchScoreReportData();
  }, []);

  React.useEffect(() => {
    fetchScoreReportData();
  }, [isClassChanged]);

  const getIncompleteScoringOption = async () => {
    try {
      const response = await getAssignmentIncompleteScoringOption().unwrap();
      setIncompleteScoringOption(response);
    } catch (error) {
      console.log(error);
    }
  };

  const getPointOptions = async () => {
    const option = {
      option: 'true'
    };
    try {
      const response = await getAssignmentPointsOPtions(option).unwrap();
      if (response) {
        setScoringOption({
          point: true,
          percentage: false
        });
      } else {
        setScoringOption({
          point: false,
          percentage: true
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const refetch = () => {
    trigger({ assignmentId: Id, pageNumber: pageNumber }).then((response) => {
      if (!response.isSuccess) {
        return;
      }
      setClassList([
        {
          name: 'All Classes',
          id: -1,
          description: 'All Classes',
          isChecked: true
        },
        ...response.data.classes.map((item) => ({
          name: item.name,
          id: item.id,
          description: item.name,
          isChecked: true
        }))
      ]);
    });
  };

  const fetchScoreReportData = async () => {
    setLoader(true);
    const data = {
      assignmentId: Id,
      classId: selectedClassIds,
      publicAssignmentId: 0,
      teacherId: 0
    };

    try {
      const response = await getScoreReport(data).unwrap();
      setScoreReportData(response);
      setLoader(false);
      setIsNoData(false);
    } catch (error) {
      setLoader(false);
      CustomToast(error.data, 'error');
      console.log(error);
      setIsNoData(true);
    }
    setPageLoader(false);
  };

  const handleClassSelectionChange = (e) => {
    const selectedClassId = parseInt(e.target.value);
    const selectedOption = classList.find((option) => option.id === selectedClassId);
    setSelectedClassName(selectedOption.name);
    setSelectedClassIds(selectedClassId);
    setIsClassChanged(!isClassChanged);
  };

  const handleIncompleteScoringOptionChange = async (e) => {
    let data = {
      incompleteScoring: e.target.checked
    };
    try {
      await patchAssignmentIncompleteScoringOption(data).unwrap();
      setIncompleteScoringOption(data.incompleteScoring);
      await fetchScoreReportData();
    } catch (error) {
      console.log(error);
    }
  };

  const pointOptionHandleChange = async (e) => {
    let option;
    if (e.target.id==='radioPoints') {
      option = {
        option: true
      };
    } else {
      option = {
        option: false
      };
    }

    setScoringOption({
      point: option.option,
      percentage: !option.option
    });

    try {
      await patchAssignmentPointsOPtions(option).unwrap();
      await fetchScoreReportData();
    } catch (err) {
      console.log(err);
    }
  };

  if (pageLoader) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
        <HesSpinner />
        <span className="ms-3">Loading results...</span>
      </div>
    );
  }

  const handlePrintPdf = async () => {
    if(isPdfGenerating) return;

    setIsPdfGenerating(true);
    const scoringOptionSave = scoringOption;

    // Generate the PDF from the HTML content
    const contentWrapper = document.getElementById('session_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const buttonGroup = contentClone.querySelector('#buttonGroup');
    buttonGroup.classList.add('d-none');
    const dropDownContainer = contentClone.querySelector('#dropdown_container');
    dropDownContainer.classList.add('d-none');
    const tables = document.getElementsByTagName('table');

    // Apply CSS styles to tables
    for (let i = 0; i < tables.length; i++) {
      const table = tables[i];
      table.style.pageBreakInside = 'avoid';
      table.style.breakInside = 'avoid';
      table.style.keepWithWindow = 'always';
    }

    // Apply CSS styles to div

    const options = {
      margin: 60, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 2 }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'landscape' }, // Set the document format and orientation (optional)
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy']
      }
    };

    await html2pdf().set(options).from(contentClone).save('ScoreReport.pdf');

    setScoringOption({
      point: scoringOptionSave.point,
      percentage: scoringOptionSave.percentage
    });
    setIsPdfGenerating(false);
  };

  const exportHandler = async () => {
    const newObjectWithNewProperties = {
      Assignment: ScoreReportData.assignment || 'Assignment Name',
      Course: ScoreReportData.course,
      Teacher: ScoreReportData.teacher,
      SchoolName: ScoreReportData.school,
      Class: ScoreReportData.class,
      'Report Date': Date().toLocaleString()
    };

    const studentList = [];

    ScoreReportData.individualResult.forEach((student) => {
      const lastName = ferpaEnabled ? student.lastName : 'Lastname hidden';
      const firstName = ferpaEnabled ? student.firstName : 'Firstname hidden';
      const identification = ferpaEnabled ? student.identification : 'Id hidden';
      const dateAssigned = student.dateAssigned;
      const dateStarted = student.dateStarted;
      const dateCompleted = student.dateCompleted;
      const correct = student.correct;
      const incorrect = student.incorrect;
      const correctOnRetry = student.correctOnRetry;
      const crAnswered = student.crAnswered;
      const score = student.score;
      const scoreWithFullCredit = student.scoreWithFullCredit;
      const scoreWithHalfCredit = student.scoreWithHalfCredit;

      studentList.push({
        LastName: lastName,
        FirstName: firstName,
        Identification: identification,
        DateAssigned: dateAssigned,
        DateStarted: dateStarted,
        DateCompleted: dateCompleted,
        Correct: correct,
        Incorrect: incorrect,
        CorrectOnRetry: correctOnRetry,
        CRAnswered: crAnswered,
        Score: score,
        ScoreWithFullCredit: scoreWithFullCredit,
        ScoreWithHalfCredit: scoreWithHalfCredit
      });      
    });

    const newData = {
      ReportOptions : newObjectWithNewProperties,
      ScoresReport: studentList
    };

    const newDataWithReportOptionsFirst = reorderObjectProperties(newData, 'ReportOptions');
    const csvData = convertToCSV(newDataWithReportOptionsFirst);
    downloadCSV(csvData, 'Scores Report-' + ScoreReportData.assignment );
  };

  return (
    <div className="white-card" id="session_pdf_Wrapper">
      <div className="student_response_header">
        <div>
          <h3>Assignment Scores Report</h3>
        </div>
        <div id="buttonGroup" className="d-flex gap-3 justify-content-end">
          <div className="d-flex me-3 align-items-center">
            <FERPA />
          </div>
          <button id="back_button" onClick={() => navigate(-1)} className="btn btn-width btn-castleWhite">
            Back
          </button>
          <button id="export_button" onClick={() => exportHandler()} className="btn btn-width btn-castleOrange">
            Export
          </button>
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={handlePrintPdf}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
            expectedDuration={1500}
          />
        </div>
      </div>
      <div id="dropdown_container" className="d-flex flex-column justify-content-start" style={{ width: '30%' }}>
        Class
        <DropDown
          value={classList}
          selectedValue={selectedClassIds}
          onChangeHandler={handleClassSelectionChange}
        />
      </div>
      <div id="print-score-report">
        <div className="student_response_details">
          <div className="d-flex justify-content-between">
            <div className="student_response_details_left">
              <p>
                Assignment: <strong>{ScoreReportData?.assignment}</strong>
              </p>
              <p>
                Course: <strong>{ScoreReportData?.course}</strong>
              </p>
              <p>
                Teacher: <strong>{ScoreReportData?.teacher}</strong>
              </p>
            </div>
            <div className="student_response_details_right">
              <p>
                School: <strong>{ScoreReportData?.school}</strong>
              </p>
              <p>
                Class:{' '}
                <strong>
                  {selectedClassName !== '' ? selectedClassName : ScoreReportData?.class}
                </strong>
              </p>
              <p>
                Report Date: <strong>{ScoreReportData?.reportDate}</strong>
              </p>
            </div>
          </div>
        </div>
        <div className="score-report">
          <div>
            <p>Show score as</p>
          </div>
          <div className="d-flex">
            <div className="d-flex gap-1 me-3">
              <input
                type="radio"
                className="form-check-input"
                checked={scoringOption.point}
                id="radioPoints"
                name="flexRadioDefault"
                onChange={(e) => pointOptionHandleChange(e)}
              />
              <label className="form-check-label">
                Points
              </label>
            </div>
            <div className="d-flex gap-1">
              <input
                type="radio"
                className="form-check-input"
                checked={scoringOption.percentage}
                id="radioPercentage"
                name="flexRadioDefault"
                onChange={(e) => pointOptionHandleChange(e)}
              />
              <label className="form-check-label">
                Percentage
              </label>
            </div>
  
            <div className="ms-5">
              <input
                type="checkbox"
                className="form-check-input me-2"
                checked={incompleteScoringOption}
                id="flexCheckDefault"
                name="allselect"
                onChange={handleIncompleteScoringOptionChange}
              />
              <label className="form-check-label">
                Score unanswered questions as incorrect
              </label>
            </div>
          </div>
        </div>
        <div className="mt-5" style={{width:'100%'}}>
          <table className={'table reportTable w-100'}>
            <thead>
              <tr className="score-table-head">
                <th className='align-content-center'>Last Name</th>
                <th className='align-content-center'>First Name</th>
                <th className='align-content-center'>Identification</th>
                <th className='align-content-center'>Date<br />Assigned</th>
                <th className='align-content-center'>Date<br />Started</th>
                <th className='align-content-center'>Date<br />Completed</th>
                <th>
                  <FontAwesomeIcon icon={faCheck} />
                </th>
                <th>
                  <FontAwesomeIcon icon={faClose} />
                </th>
                <th>
                  <FontAwesomeIcon icon={faClose} /><FontAwesomeIcon icon={faCheck} /> 
                </th>
                <th>CR<br></br>Answered</th>
                <th>Score</th>
                <th>Score With Retry<br></br>As Full-Credit</th>
                <th>Score With Retry<br></br>As Half-Credit</th>
              </tr>
            </thead>
            <tbody>
            {!loader ? (
              <>
                {!isNoData?(
                  <>
                    {ScoreReportData?.individualResult?.map((item) => (
                      <tr className="table-body" key={`${item.studentId}-record`}>
                        {ferpaEnabled?<td>{item.lastName}</td>:<td>Lastname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.firstName}</td>:<td>Firstname<br></br>hidden</td>}
                        {ferpaEnabled?<td>{item.identification}</td>:<td>Id<br></br>hidden</td>}
                        <td>{item.dateAssigned}</td>
                        <td>{item.dateStarted}</td>
                        <td>{item.dateCompleted}</td>
                        <td>{item.correct}</td>
                        <td>{item.incorrect}</td>
                        <td>{item.correctOnRetry}</td>
                        <td>{item.crAnswered}</td>
                        <td>{item.score}</td>
                        <td>{item.scoreWithFullCredit}</td>
                        <td>{item.scoreWithHalfCredit}</td>
                      </tr>
                    ))}
                  </>
                ):(
                  <>
                    <tr className="table-body" style={{height:'200px'}}>
                    </tr>
                  </>
                )}
              </>
            ):(
              <tr className="table-body" style={{height:'200px'}}>
                <td colSpan={13}>
                  <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                    <div id="spinnerdiv" style={{height:'30px'}}>
                      <HesSpinner />
                    </div>
                    <span className="ms-3">Loading results...</span>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
          </table>
        </div>
      
        <div className="scoreInfo d-flex col-12">
          <div className="scoreInfoIcon info-text">
            <span>
              <FontAwesomeIcon icon={faInfo} />
            </span>
          </div>
          <div className="scoreInfoText">
            <p>
              <strong>Score:</strong> counts only the first answer attempt as correct
            </p>
            <p>
              <strong>Score With Retry As Full-Credit:</strong> counts correct answers on a retry as
            full-credit
            </p>
            <p>
              <strong>Score With Retry As Half-Credit:</strong> counts correct answers on a retry as
            half-credit
            </p>
            <p>All percent scores rounded to nearest whole number</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScoreReport;
